import { useSelector } from 'react-redux';
import Subheader from './header/Subheader';
import MiddleSchoolSubheader from './MiddleSchoolSubheader';
import { RootState } from '../ApplicationState';
import { selectClassroom } from '../Classrooms';

interface Props {
  [key: string]: unknown;
}

const SubheaderRedirect = (props: Props): JSX.Element => {
  const newProps = { ...props };
  const classroom = useSelector((state: RootState) => {
    const selectedClassroom = selectClassroom(state);
    return selectedClassroom;
  });
  return (
    <>
      {classroom === undefined ? null : parseInt(classroom?.grade) > 5 ? (
        <MiddleSchoolSubheader {...newProps} />
      ) : (
        <Subheader {...newProps} />
      )}
    </>
  );
};

export default SubheaderRedirect;
